import { OrganizerInfoExperimentValues } from './types';

const LISTING_PAGE_EXPERIMENTS_LAYER = 'listing_page_experiments';

// Statsig's Events

export const STATSIG_EVENT_NAMES = {
    LISTING_APP_PAGE_VIEW: 'Listing - App - View - Page',
    LISTING_CONVERSION_BAR_CTA_CLICK: 'Listing - conversionBar - Click - CTA',
    LISTING_TICKET_SELECTION_VIEW:
        'Listing - Conversion Bar - Ticket Selection - View',
    LISTING_ORGANIZER_TOP_FOLLOW_BUTTON_CLICK:
        'Listing - Hero Content - Follow Button - Change',
    LISTING_ORGANIZER_BOTTOM_FOLLOW_BUTTON_CLICK:
        'Listing - Organizer Profile - Follow Button - Change',
    LISTING_ORGANIZER_BLUE_FOLLOW_BUTTON:
        'Listing - Organizer Panel - Blue Follow Button - Change',
    LISTING_ORGANIZER_WHITE_FOLLOW_BUTTON:
        'Listing - Organizer Panel - White Follow Button - Change',
    LISTING_ORGANIZER_FOLLOW_BUTTON: 'Listing - Follow Button - Change',
};

// Statsig's Feature Gates

export const DISPLAY_ORGANIZER_RATING_GATE = 'listing_display_organizer_rating';

// Statsig's Layers

export const LISTING_PAGE_TICKET_SELECTION_EXPERIMENT = {
    defaultValue: false,
    layer: LISTING_PAGE_EXPERIMENTS_LAYER,
    param: 'ticket_selection_visible',
};

// Heap ID's

export const LISTING_HEAP_IDS = {
    CHILD_EVENTS_DROPDOWN: 'Listing - Date - Child Events Dropdown - Click',
    CTA_SELECT_A_DATE: 'Listing - Conversion Bar - Select a Date - Click',
    CTA_RSVP_MAYBE: 'Listing - Conversion Bar - RSVP Maybe - Click',
    CTA_RSVP_NO: 'Listing - Conversion Bar - RSVP No - Click',
    DESCRIPTIVE_ORGANIZER:
        'Listing - Descriptive Organizer Panel - Follow - Click',
    HERO_SHARE_EVENT: 'Listing - Hero - Share - Click',
    HIDE_MAP: 'Listing - Hide Map - Button - Click',
    MAP_DRIVE: 'Listing - Map - Drive - Click',
    MAP_WALK: 'Listing - Map - Walk - Click',
    MAP_BUS: 'Listing - Map - Bus - Click',
    MAP_BIKE: 'Listing - Map - Bike - Click',
    MAP_ZOOM_CHANGE: 'Listing - Map - Zoom - Change',
    ONLINE_EVENT_ACCESS_BUTTON:
        'Listing - Online Location - Access the Event - Click',
    ORGANIZER_FACEBOOK:
        'Listing - Organizer Panel - Organizer Facebook - Click',
    ORGANIZER_NAME: 'Listing - Organizer Panel - Organizer Name - Click',
    ORGANIZER_TWITTER: 'Listing - Organizer Panel - Organizer Twitter - Click',
    ORGANIZER_WEBSITE: 'Listing - Organizer Panel - Organizer Website - Click',
    SHOW_MAP: 'Listing - Show Map - Button - Click',
    SIMPLIFIED_ORGANIZER:
        'Listing - Simplified Organizer Panel - Follow - Click',
};

// Statsig's Organizer Panel Experiment

export const LISTING_PAGE_ORGANIZER_PANEL_EXPERIMENT = {
    defaultValue: OrganizerInfoExperimentValues.default,
    layer: LISTING_PAGE_EXPERIMENTS_LAYER,
    param: 'organizer_panel',
    variantAValue: OrganizerInfoExperimentValues.blueFollowButtonVariant,
    variantBValue: OrganizerInfoExperimentValues.whiteFollowButtonVariant,
};
